const HeaderPage = ({ isLoading: _ }: { isLoading: boolean }) => (
	<div className="flex items-center mb-4">
		<h2 className="text-lg font-semibold tracking-tight">Transactions</h2>
	</div>
);

export default HeaderPage;
